import DI from './index';
import recipes from './recipes';

let di = new DI();

for (const [key, recipe] of Object.entries(recipes)) {
    di.register(key, recipe);
}

export default di;